import { useContext, useEffect, useState } from "react";
import styles from "./NewAd.module.css";
import NewAdPartOne from "../../components/NewAd/NewAdPartOne/NewAdPartOne";
import NewAdPartTwo from "../../components/NewAd/NewAdPartTwo/NewAdPartTwo";
import { WizardFormData } from "../../Models/WizardModel";
import { arrow_right, documentIcon, eyeIcon, penIcon} from "../../assets/icons";
import { WizardContext } from "../../Store/Wizard.store";
import NewAdPartThree from "../../components/NewAd/NewAdPartThree/NewAdPartThree";
import NewAdFinal from "../../components/NewAd/NewAdFinal/NewAdFinal";
import { AccountContext } from "../../Store/Account.store";
import { useLocation, useNavigate } from "react-router-dom";


export default function NewAd() {
  const emptyWizardFormData: WizardFormData = {
    wizardStep: 1,
    initialSetup: true,
    alternativeFilter: [],
    editMode: false,
    adData: {
      id: 0,
      title: "",
      description: "",
      alternativeToCategories: [],
      supplementaryInformation: "",
      useCategories: [],
      sectorCategories: [],
      certificationCategories: [],
      isBioBased: false,
      casNumber: "",
      technicalDataSheet: undefined,
      safetyDataSheet: undefined,
      additionalDocuments: undefined,
      additionalInformation: "",
      companyName: "",
      companyGroupId: 0,
      companyWebsite: "",
      contactName: "",
      contactEmail: "",
      logotype: {
        fileData: new File([""], ""),
        fileName: "",
        mimeType: "",
        id: 0,
      },
      alternativeLevel: 0
    },
  };
  const [wizardFormData, setWizardFormData] = useState<WizardFormData>(useLocation().state != null ? useLocation().state : emptyWizardFormData);
  const {accountData} = useContext(AccountContext);
  const navigate = useNavigate();
  useEffect(() => {
    if(!accountData.isauthenticated){
      navigate("/sign-in");
    }
  },[])

  const backButton = (buttonText: string) => {
    return (
      <button
        className={styles.back_button}
        onClick={() =>
          setWizardFormData({
            ...wizardFormData,
            wizardStep: wizardFormData.wizardStep - 1,
          })
        }
      >
        {arrow_right}
        <span>Back: {buttonText}</span>
      </button>
    );
  };

  const adPossition = () => {
    return (
      <div className={styles.position_elements}>
        <div
          className={`${styles.position_container} ${
            wizardFormData.wizardStep >= 1 ? styles.active : ""
          }`}
        >
          <div>{documentIcon}</div>
          <span>Contact information</span>
        </div>
        <div
          className={`${styles.position_container} ${
            wizardFormData.wizardStep >= 2 ? styles.active : ""
          }`}
        >
          <div>{penIcon}</div>
          {wizardFormData.editMode ? 
          <span>Modify your ad</span> :
          <span>Create your ad</span>
          }
        </div>
        <div
          className={`${styles.position_container} ${
            wizardFormData.wizardStep >= 3 ? styles.active : ""
          }`}
        >
          <div>{eyeIcon}</div>
          <span>Preview your ad and submit</span>
        </div>
        <div className={styles.line}></div>
      </div>
    );
  };
  const wizardValueData = { wizardFormData, setWizardFormData };
  return (
    <WizardContext.Provider value={wizardValueData}>
      <div className={`${styles.newpart_one} container`}>
        <div className={styles.all_content}>
          {wizardFormData.wizardStep === 4 ? (
            <div className={`${styles.newpart_one} container`}>
              <NewAdFinal />
            </div>
          ) : (
            <>
              <div className={styles.start}>
                <h1>Advertise your alternative</h1>
                <p>
                  Boost your digital presence by advertising your safer
                  solutions effortlessly through easy-to-upload advertisements
                  and reach new customers worldwide with a single global
                  tool.
                </p>
              </div>
              {adPossition()}
              <form>
                {wizardFormData.wizardStep === 1 && <NewAdPartOne />}
                {wizardFormData.wizardStep === 2 && (
                  <NewAdPartTwo
                    backButton={() => backButton("Contact information")}
                  />
                )}
                {wizardFormData.wizardStep === 3 && (
                  <NewAdPartThree
                    backButton={() => backButton(wizardFormData.editMode ? "Updated your ad" :"Create your ad")}
                  />
                )}
              </form>
            </>
          )}
        </div>
      </div>
    </WizardContext.Provider>
  );
}
